<div *ngIf="mensagens.length > 0">
<p *ngFor="let item of mensagens">{{ item }}</p>
</div>